// Angular modules
import { HttpClient }    from '@angular/common/http';
import { Injectable }    from '@angular/core';

// Ionic modules
import { Platform }      from 'ionic-angular';

// External modules
import * as countries    from 'i18n-iso-countries';
import { Observable }    from 'rxjs/Rx';
import 'rxjs/add/operator/map'                           ;
import { catchError }    from 'rxjs/operators';
import { map }           from 'rxjs/operators';
import { switchMap }     from 'rxjs/operators';

// Helpers
import { StorageHelper } from '../helpers/storage.helper';
import { Translation } from '../models/translation';
import { IndexedDbHelper } from '../helpers/indexed-db.helper';

// load languages
declare var require: any;
countries.registerLocale(require("i18n-iso-countries/langs/en.json"));

@Injectable()
export class ApplicationService
{
  constructor(
    public  platform   : Platform,
    private http       : HttpClient)
  {}

  getCountryCodeFromCoords(): Observable<{ code: string; name: string }>
  {
    return this.http.get(`https://ipv4.icanhazip.com`, { responseType: 'text' }).pipe(
      switchMap((ipAddress) =>
      {
        ipAddress = ipAddress.replace(/\n/g, '');
        return this.http.get<any>(`https://ipinfo.io/${ipAddress}/json?token=74a2996404fb1f`).pipe(
          map((res) => ({
              code: res.country.toLocaleLowerCase(),
              name: countries.getName(res.country, 'en')
          })),
          catchError((error: any) => Observable.throw(error || 'Server error'))
        )
      })
    );
  }

  async getSelectedLanguage()
  {
    const selected = StorageHelper.getSelectedLanguage();
    if(selected == null)
    {
      StorageHelper.setSelectedLanguage("en-GB");
      return "en-GB";
    }

    return selected;
  }

  async getSelectedTranslations(): Promise<Translation[]>
  {
    const selectedLanguage = await this.getSelectedLanguage();
    return await IndexedDbHelper.getTranslations(selectedLanguage);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/providers/application-service.ts